import { RefObject, useEffect } from 'react';
import { CommunicationMessageEvents } from '../../interfaces/message-events';
import { DocWindowMessage } from '../interfaces/setup-guide-tracking';

export function useIframeMessage({
  iframeOrigin,
  iframeRef,
  onMessageFromIframe
}: {
  iframeOrigin: string;
  iframeRef: RefObject<HTMLIFrameElement>;
  onMessageFromIframe: (message: DocWindowMessage) => void;
}) {
  useEffect(() => {
    window.addEventListener('message', handleMessagesFromIframe);
    return () => window.removeEventListener('message', handleMessagesFromIframe);
  }, []);

  const handleMessagesFromIframe = (e: MessageEvent) => {
    if (e.origin !== iframeOrigin) {
      return;
    }

    onMessageFromIframe(e.data);
  };

  const sendMessageToIframe = (event: CommunicationMessageEvents, data: object) => {
    const message: DocWindowMessage = {
      event,
      data: {
        ...data
      }
    };

    try {
      if (iframeRef.current) {
        iframeRef.current.contentWindow?.postMessage(message, iframeOrigin);
      }
    } catch (error) {
      /* empty */
    }
  };

  return {
    sendMessageToIframe
  };
}
